/*
 app dependencies
 - var body

 lib dependencies
*/

const scSidebarAddOwner = (function($)
{
    //public
    const   sidebarId = 'add-owner';
    //private
    const   _triggers = document.querySelectorAll(`.js-show-sidebar[data-sidebar-id="${sidebarId}"]`),
            _bodyToggleClass = `show-sidebar-${sidebarId}`,
            _personSelect = document.querySelector('select.js-add-statement-person-input'),
            _organisationSelect = document.querySelector('select.js-add-statement-organisation-input');
    let     _sidebarDiv,
            _form;

	//module functions
	function init()
	{
		for (const trigger of _triggers)
        {
            trigger.addEventListener('click', function(e)
            {
                e.preventDefault();
                _show();
            });
        }
	}

    function _show()
    {
        scSidebar.show(_bodyToggleClass);
    }

    function contentLoaded(sidebarDiv)
    {
        //references to elements
        _sidebarDiv = sidebarDiv;
        _form = _sidebarDiv.querySelector('form');

        //init
        _initForm();
    }

    function _initForm()
    {
        _form.addEventListener('submit', function(e)
        {
            e.preventDefault();

            if ($(this).validateForm())
            {
                _sidebarDiv.classList.add('sidebar--loading');

                doAjax({
                    ajaxUrl: this.getAttribute('action'),
                    data: $(this).serializeArray(),
                    onSuccess: _onAddSuccess,
                    onError: _onAddError
                });
            }
        });
    }

        function _onAddSuccess(rawResponse, params)
        {
            _sidebarDiv.classList.remove('sidebar--loading');

            try
            {
                var response = $.parseJSON(rawResponse);
                if (response.success)
                {
                    //update page
                    _personSelect.insertAdjacentHTML('beforeend', `<option value="${response.id}" selected="selected">${response.name}</option>`); //(${response.organisation})
                    if (response.organisationId) _organisationSelect.value = response.organisationId;
                    scUi.updateChosen($('.js-add-statement-form'));
                    //close sidebar
                    scSidebar.hide();
                    //reset form in sidebar
                    _form.reset();
                    scUi.updateChosen($(_sidebarDiv));
                }
                else throw new Error(response.message);
            }
            catch (err) { alert(err.message); }
        }


        function _onAddError(jqxhr, textStatus, errorThrown, params)
        {
            _sidebarDiv.classList.remove('sidebar--loading');
            //error?
            if (!userAbortedAjax(jqxhr)) alert(errorThrown);
        }

	//reveal public vars and functions
	return {
		//vars
        sidebarId,
		//functions
		init,
        contentLoaded
	};

})(jQuery);
